import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { contabilidadeDigitalTranslations, createCdPaths } from '@ibk/contabilidade-digital';
import { TranslationProvider, useTranslation } from '@ibk/shared-translation';
import { Loading, NavBar } from '@ibk/shared-ui';
import { dominioEscritorioTranslations } from '../../translations';
import ContabilidadeDigital from './ContabilidadeDigital';
export default function ContabilidadeLayout() {
    const combinedTranslations = {
        'pt-BR': {
            ...dominioEscritorioTranslations['pt-BR'],
            ...contabilidadeDigitalTranslations['pt-BR'],
        },
        'en-US': {
            ...dominioEscritorioTranslations['en-US'],
            ...contabilidadeDigitalTranslations['en-US'],
        },
        'es-ES': {
            ...dominioEscritorioTranslations['es-ES'],
            ...contabilidadeDigitalTranslations['es-ES'],
        },
    };
    return (_jsx(TranslationProvider, { translations: combinedTranslations, defaultLanguage: 'pt-BR', children: _jsx(LayoutContent, {}) }));
}
function LayoutContent() {
    const { t } = useTranslation();
    const navItems = [{ title: t('contabilidade-digital.dashboard.connected-accounts'), route: createCdPaths().base }];
    return (_jsxs("div", { children: [_jsx(NavBar, { routes: navItems }), _jsx("main", { children: _jsx(Suspense, { fallback: _jsx(Loading, { fullScreen: true }), children: _jsxs(Routes, { children: [_jsx(Route, { index: true, element: _jsx(Navigate, { to: 'contas-conectadas', replace: true }) }), _jsx(Route, { path: 'contas-conectadas/*', element: _jsx(ContabilidadeDigital, {}) })] }) }) })] }));
}
